"use client";

import { useDialog } from "@/hooks/use-dialog";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";
import { QuestionIcon } from "ui/icon/shared";

export const InvestmentStylePopover = () => {
  const { Dialog, openDialog, closeDialog } = useDialog();
  const { t } = useLang();
  return (
    <>
      <QuestionIcon
        className="h-4 w-4 cursor-pointer select-none hover:fill-[#196089] hover:shadow-sm"
        onClick={() => openDialog()}
      />
      <Dialog title={t.my13F.investor.institutionalInvestingStyle} width={800}>
        <div className="flex flex-col items-center gap-y-9 px-6 py-7 sm:px-14">
          <div className="flex w-full flex-col gap-y-2 text-sm">
            <p className="font-medium">{t.my13F.investor.styleIllustration}</p>
            {t.my13F.investor.styleDescriptions.map((style) => (
              <p key={style.title}>
                <span className="font-medium text-[#2D80AF]">
                  {style.title}
                </span>
                ：{style.description}
              </p>
            ))}
          </div>
          <Button
            className="w-full max-w-[300px]"
            onClick={() => closeDialog()}
          >
            {t.my13F.investor.close}
          </Button>
        </div>
      </Dialog>
    </>
  );
};
